import React from 'react';
import { Link } from 'react-router-dom';
import { initials, posAbbrev, fmtHtWt, classOf } from './listFormat';
import StarGrade from './StarGrade';

function MemberExtras({ m, canEdit, onUpdate }) {
  const [note, setNote] = React.useState(m.note || '');
  React.useEffect(() => { setNote(m.note || ''); }, [m.note, m.user_id]);
  if (!canEdit) {
    if (!m.grade && !m.note) return null;
    return (
      <div className="ls-mextra">
        {m.grade ? <StarGrade value={m.grade} /> : null}
        {m.note ? <span className="ls-mnote">{m.note}</span> : null}
      </div>
    );
  }
  return (
    <div className="ls-mextra">
      <StarGrade value={m.grade} label={`Grade for ${m.name}`}
        onChange={(grade) => onUpdate(m.user_id, { grade })} />
      <input className="ls-note" type="text" value={note} placeholder="Add a note" aria-label={`Note for ${m.name}`}
        onChange={(e) => setNote(e.target.value)}
        onBlur={() => { if (note.trim() !== (m.note || '')) onUpdate(m.user_id, { note: note.trim() }); }}
        onKeyDown={(e) => { if (e.key === 'Enter') e.currentTarget.blur(); }} />
    </div>
  );
}

export default function ListMembers({ members, canEdit, addedUid, onRemove, onUpdate = () => {} }) {
  if (!members.length) {
    return <p className="ls-empty">No athletes on this list yet.</p>;
  }
  return (
    <div className="ls-members" data-testid="list_members">
      {/* An editable list shows its count on the "On this list" tab, so the caption keeps only the order; a
          read-only list has no tab strip, so its caption keeps the count. */}
      {canEdit ? (
        <div className="ls-members__caption" data-testid="list_members_caption">
          <span className="ls-members__order">newest first</span>
        </div>
      ) : (
        <div className="ls-members__caption ls-members__caption--count" data-testid="list_members_caption">
          {`On this list · ${members.length}`}<span className="ls-members__order">newest first</span>
        </div>
      )}
      <div className="ls-mrow ls-mrow--head" aria-hidden="true">
        <div>Athlete</div><div>Pos</div><div>Class</div><div>Ht / Wt</div><div>40yd</div><div>GPA</div><div />
      </div>
      {members.map((m) => (
        <React.Fragment key={m.user_id}>
        <div className="ls-mrow" data-testid={`list_member_${m.user_id}`}>
          <div className="ls-mathlete">
            <span className="ls-avatar" aria-hidden="true">{initials(m.name)}</span>
            <Link to={`/athletes/${m.user_id}`} className="ls-mathlete__name">{m.name}</Link>
            {addedUid === m.user_id && <span className="ls-chip-added">Added</span>}
          </div>
          <div className="ls-cell">{posAbbrev(m.position)}</div>
          <div className="ls-cell">{classOf(m)}</div>
          <div className="ls-cell">{fmtHtWt(m)}</div>
          <div className="ls-cell">{m.dash_40 || '—'}</div>
          <div className="ls-cell">{m.gpa_weighted || '—'}</div>
          <div className="ls-cell ls-cell--end">
            {canEdit && (
              <button type="button" className="ls-remove" onClick={() => onRemove(m.user_id)}
                data-testid={`list_remove_${m.user_id}`} aria-label={`Remove ${m.name}`}>Remove</button>
            )}
          </div>
        </div>
        <MemberExtras m={m} canEdit={canEdit} onUpdate={onUpdate} />
        </React.Fragment>
      ))}
    </div>
  );
}
